import { render } from "./createLotComponent.vue?vue&type=template&id=524f6828"
import script from "./createLotComponent.vue?vue&type=script&lang=js"
export * from "./createLotComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__